// extracted by mini-css-extract-plugin
module.exports = {"Price":"price_Price__YgsoI","PriceInfo":"price_PriceInfo__CNvqq","BeforeValue":"price_BeforeValue__3XC7_","LastValue":"price_LastValue__aAFWL","Value":"price_Value__TGtcM"};